enum GUEST_STATUSES {
  incomplete = 'INCOMPLETE',
  error = 'ERROR',
  new = 'NEW',
  complete = 'COMPLETED',
  verification_pending = 'VERIFICATION_PENDING',
}

enum GROUP_TYPES {
  single = 'S',
  group = 'G',
  family = 'F',
  tourist = 'T',
}

const GUEST_DETAILS_REGISTERED_STATUSES = [
  GUEST_STATUSES.verification_pending,
  GUEST_STATUSES.complete,
];

export {GUEST_STATUSES, GROUP_TYPES, GUEST_DETAILS_REGISTERED_STATUSES};
